import { render, staticRenderFns } from "./EditRate2.vue?vue&type=template&id=529e4fab&"
import script from "./EditRate2.vue?vue&type=script&lang=js&"
export * from "./EditRate2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports